module.exports = __webpack_public_path__ + "static/Biographical_Sketch_Stapleton-0a3ff6dc2fe28e4ead55f281cda504cd.pdf";